import Api from "./Api";

export default class extends Api {
    constructor(){
        super(process.env.REACT_APP_OCCURRENCE_ENDPOINT);
    }
}